import _ from 'lodash'

export const isMediaTableEvent = (eventData) => {
  const apps = eventData?.data?.apps ?? []
  return !_.isEmpty(apps.filter((app) => app.style.startsWith('media')))
}

export const isSelectableMediaEvent = (mediaType, targetId) => {
  return (mediaType ?? '').indexOf('img') > -1 && !targetId.includes('overlay:media')
}

export const isNewMediaAppEvent = (eventData) => {
  if (_.isEmpty(eventData)) {
    return false
  }

  const ui = eventData?.ui ?? []
  const updateData = eventData?.updateData ?? []

  return eventData.action === 'reselect' &&
    _.isEmpty(eventData.showTargets) &&
    _.size(updateData) === 1 &&
    !_.isEmpty(updateData.find(i => i.data.type === 'img' && !i.data.editmode)) &&
    !_.isEmpty(ui.find(ui => ui.id.includes('media')))
}
